/** @format */

import React, { Component } from 'react';
import Select from 'react-select';
import I18n from '../Translate/I18n';

const _ = require('underscore');

class SelectSingleRestExt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selected,
        };
    }

    getTranslate = (text) => {
        if (!text) {
            return null;
        }
        return <I18n trans={text} />;
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.selected !== nextState.selected && nextProps.selected !== null) {
            this.setState({ selected: nextProps.selected });
        }
        return true;
    }

    onUpdate = (e) => {
        this.setState({
            selected: e,
        });
        this.props.onChange(e);
    };

    render() {
        const { options, name, label, helperText } = this.props;
        let o = [{ value: '', label: <I18n trans="general:common.empty_select_list" /> }];
        if (options && _.size(options['hydra:member']) !== 0) {
            o = options['hydra:member'].map((row) => {
                return {
                    value: row.id,
                    label: row.mainname,
                };
            });
        }
        return (
            <Select
                options={o}
                name={name}
                value={this.state.selected}
                onChange={this.onUpdate}
                helperText={this.getTranslate(helperText)}
                label={this.getTranslate(label)}
            />
        );
    }
}

export default SelectSingleRestExt;
